import React from 'react';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';

const DateSelector = ({ selectedDate, onDateChange, shouldDisableDate }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
        <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
        Select Date
      </h3>
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <StaticDatePicker
            value={selectedDate}
            onChange={onDateChange}
            disablePast
            shouldDisableDate={shouldDisableDate}
            sx={{
              '& .MuiPickersDay-root': {
                '&.Mui-selected': {
                  backgroundColor: '#445485',
                  '&:hover': {
                    backgroundColor: '#3a4674',
                  },
                },
              },
              '& .MuiPickersCalendarHeader-label': {
                color: '#445485',
                fontWeight: 'bold',
              },
            }}
          />
        </LocalizationProvider>
      </div>
    </div>
  );
};

export default DateSelector;